import React from 'react';
import {useSuspenseQueries} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import {WebviewUtils} from '@shared/webviewUtils';
import {ApiResponseGetConsentResponse, VehicleInfo} from '@di-shared/api/di/__generated';

export interface ConsentBannerKrProps {
  vin: string;
}

function ConsentBannerKr({vin}: ConsentBannerKrProps) {
  const {t} = useInferableTranslation();
  const puid = environmentStore.getState().puid;

  const [{data: consentData}, {data: vehicleInfo}] = useSuspenseQueries({
    queries: [
      {
        queryKey: [getQueryKey(diApi.consentController.getConsentService), vin],
        queryFn: () => diApi.consentController.getConsentService({vin, consentType: 'GPS'}),
        select: ({data}: ApiResponseGetConsentResponse) => data,
      },
      {
        queryKey: [getQueryKey(diApi.vehicle.getVehicle), vin, puid],
        queryFn: () => diApi.vehicle.getVehicle({vin, puid}),
        select: (data: VehicleInfo) => data,
      },
    ],
  });

  function linkToAppSettings() {
    WebviewUtils.close('app://ccsPlan');
  }

  return !consentData.enabled ? (
    vehicleInfo.primaryUserYn ? (
      <div className="guide_banner">
        <p className="guide_banner_desc">{t('T20205')}</p>
        <button
          type="button"
          className="btn_hyperlink"
          onClick={() => linkToAppSettings()}
        >
          {t('T20206')}
        </button>
      </div>
    ) : (
      <div className="guide_banner">
        <p className="guide_banner_desc">{t('T20207')}</p>
      </div>
    )
  ) : (
    <></>
  );
}

export default ConsentBannerKr;
